import Header from "../components/Header";
import { star, starperson, lamp } from "../assets/icons/index";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import Title from "../components/Title";
import { CONTACT_PATH } from "../Routes/paths";
import { useNavigate } from "react-router-dom";
import Contact from "../components/Contact";

interface AboutUsProps {}

const AboutUs = ({}: AboutUsProps) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Header />

      <main
        className={`w-full ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* hero section  *****************************/}
        <Title title={t("About Us")} subtitle={t("About Us")} />

        {/* next section  ******************************/}
        <section className="my-[20px] px-[20px] w-full flex flex-col items-center justify-center gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
          <div>
            <img src="../images/aboutintro.png" alt="" />
          </div>
          <div>
            <p
              className={`max-w-[800px] lg:text-[14px] text-center ${
                i18n.language === "en" ? "lg:text-left" : "lg:text-right"
              }`}
            >
              {t(
                "Explores cutting-edge advancements and inventive strategies transcending traditional software boundaries. This title delves into breakthrough technologies, creative problem-solving approaches, and forward-thinking methodologies that redefine the future of tech industries and business innovation. Discover how visionary ideas are transforming tomorrow's digital landscape through agile development, AI-driven solutions, disruptive innovations, and next-generation platforms. Uncover the dynamic interplay between technology and human ingenuity, driving unprecedented progress and revolutionizing how businesses operate and evolve in an ever-changing digital world."
              )}
            </p>
          </div>
        </section>

        {/* Why Choose Us?  ****************************/}
        <section className="my-[100px] px-[20px] lg:px-[80px] w-full flex flex-col gap-10 ">
          <p className="font-[700] text-[24px] lg:text-[28px] flex items-center justify-center">
            {t("Why Choose Us?")}
          </p>
          <div className="flex flex-col gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
            <div className="flex flex-col items-start gap-2">
              <img src={star} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Expertise and Experience")}
              </p>
              <p
                className={`lg:text-[14px] max-w-[330px] ${
                  i18n.language === "en" ? "text-left" : "text-right"
                }`}
              >
                {t(
                  "Our team comprises seasoned professionals with years of experience in the software industry"
                )}
              </p>
            </div>

            <div className="flex flex-col items-start gap-2">
              <img src={lamp} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Innovative Solutions")}
              </p>
              <p
                className={`lg:text-[14px] max-w-[330px] ${
                  i18n.language === "en" ? "text-left" : "text-right"
                }`}
              >
                {t(
                  "We stay ahead of the curve by constantly embracing the latest technologies."
                )}
              </p>
            </div>

            <div className="flex flex-col items-start gap-2">
              <img src={starperson} alt="" />
              <p className="font-[700] text-[18px] lg:text-[20px]">
                {t("Customer-Centric Approach")}
              </p>
              <p
                className={`lg:text-[14px] max-w-[330px] ${
                  i18n.language === "en" ? "text-left" : "text-right"
                }`}
              >
                {t(
                  "We deliver solutions that truly align with your business objectives."
                )}
              </p>
            </div>
          </div>
        </section>

        {/* Our Values *********************************/}
        <section className="my-[100px] px-[20px] lg:px-[144px] 2xl:px-[180px] w-full flex flex-col gap-10 ">
          <p className="font-[700] text-[24px] lg:text-[28px] flex items-center justify-center">
            {t("Our Values")}
          </p>
          {/* grid section  *****************/}
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <p className="font-[700] text-[20px]">{t("Innovation")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We embrace cutting-edge technologies and methodologies to deliver forward-thinking solutions."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">{t("Integrity")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We conduct our business with the highest ethical standards, ensuring trust and reliability."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">{t("Excellence")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We strive for excellence in everything we do, from the initial consultation to the final delivery."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">{t("Collaboration")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We believe in the power of teamwork and open communication, working closely with our clients to achieve the best results."
                )}
              </p>
            </div>
          </div>
        </section>

        {/* Connect With Us: Your Voice Heard **************/}
        <Contact />
      </main>

      <Footer />
    </>
  );
};

export default AboutUs;
